namespace TabAurous.Production {
    export interface IssueMaterialForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        AutoPosting: Serenity.BooleanEditor;
        VoucherNo: Serenity.StringEditor;
        UserId: Serenity.LookupEditor;
        Details: IssueMaterialDetailsEditor;
        EmployeeId: Serenity.IntegerEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
    }

    export class IssueMaterialForm extends Serenity.PrefixedContext {
        static formKey = 'Production.IssueMaterial';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IssueMaterialForm.init)  {
                IssueMaterialForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.BooleanEditor;
                var w4 = s.StringEditor;
                var w5 = s.LookupEditor;
                var w6 = IssueMaterialDetailsEditor;

                Q.initFormType(IssueMaterialForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'VoucherTypeId', w2,
                    'AutoPosting', w3,
                    'VoucherNo', w4,
                    'UserId', w5,
                    'Details', w6,
                    'EmployeeId', w2,
                    'CompanyId', w2,
                    'FinancialYearId', w2
                ]);
            }
        }
    }
}
